// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legacy-batch-measure-dialog .mat-mdc-dialog-surface {
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  overflow: visible;
}

.legacy-batch-measure-dialog .mat-mdc-dialog-content,
.legacy-batch-measure-dialog .mat-mdc-dialog-container {
  padding: 0;
}

.bmd-dialog {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  width: 1008px;
  max-width: 95vw;
  box-sizing: border-box;
  font-family: 'GothamNarrowBook', Arial, sans-serif;
}

.bmd-header {
  background: #0b2d71;
  padding: 10px 20px;
  display: flex;
  align-items: baseline;
  gap: 0;
}

.bmd-title-main {
  color: #fff;
  font-size: 26px;
  font-weight: 600;
}

.bmd-title-sep {
  color: #fff;
  font-size: 26px;
}

.bmd-title-name {
  color: #fff;
  font-size: 26px;
  font-style: italic;
  font-weight: 400;
}

.bmd-body {
  padding: 15px 25px 18px;
  display: flex;
  flex-direction: column;
  gap: 0;
  font-size: 24px;
}

.bmd-scan-banner {
  border: 1px solid #222;
  padding: 5px 12px;
  text-align: center;
  color: maroon;
  font-weight: 700;
  margin: 0 15px 18px;
}

.bmd-scanner-target-note {
  margin: -10px 15px 14px;
  color: #374151;
  font-size: 16px;
  text-align: center;
}

.bmd-scanner-input {
  position: fixed;
  left: -10000px;
  top: 0;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.bmd-section-label {
  font-weight: 700;
  color: #111;
  margin: 0 0 7px 34px;
}

.bmd-row {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: 59px;
  margin-bottom: 28px;
}

.bmd-label-w1 {
  flex: 0 0 130px;
  color: #374151;
}

.bmd-label-w2 {
  flex: 0 0 110px;
  color: #374151;
  margin-left: 30px;
}

.bmd-value-box {
  flex: 0 0 266px;
  width: 266px;
  min-width: 266px;
  max-width: 266px;
  padding: 4px 8px;
  border: 1px solid #d1d5db;
  border-radius: 2px;
  background: #f3f4f6;
  min-height: 40px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  font-size: 24px;
}

.bmd-input-box {
  flex: 0 0 266px;
  width: 266px;
  min-width: 266px;
  max-width: 266px;
  box-sizing: border-box;
  height: 40px;
  font-size: 24px;
}

.bmd-scale-note {
  margin: -18px 0 18px 454px;
  font-size: 16px;
  color: #374151;
}

.bmd-comments-input {
  flex: 1;
  min-width: 120px;
  box-sizing: border-box;
  font-size: 24px;
}

.bmd-container-grid {
  display: grid;
  grid-template-columns: 130px 266px 140px 266px;
  -moz-column-gap: 5px;
       column-gap: 5px;
  row-gap: 7px;
  align-items: center;
  margin-left: 59px;
  margin-bottom: 25px;
}

.bmd-container-grid .bmd-label-w2 {
  margin-left: 0;
  padding-left: 30px;
  box-sizing: border-box;
}

.bmd-container-grid .bmd-value-box {
  flex-basis: auto;
  width: 266px;
}

.bmd-check-cell {
  grid-column: 1 / 3;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
}

.bmd-check-cell input {
  width: 14px;
  height: 14px;
  margin: 0;
}

.bmd-container-grid button {
  grid-column: 4;
  width: 266px;
  min-height: 40px;
  font-size: 18px;
}

.bmd-notes {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
  font-size: 18px;
  margin-left: 59px;
}

.bmd-error {
  color: #dc2626;
}

.bmd-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px;
  border-top: 1px solid #e2e8f0;
  margin-top: 0;
}

.bmd-actions button {
  width: 100px;
  min-height: 34px;
  font-size: 18px;
}

.bmd-critical-warning {
  border: 2px solid #b91c1c;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 22px;
  font-weight: 700;
  margin: 0 15px 18px;
  padding: 8px 12px;
  text-align: center;
}

.bmd-comment-dialog {
  width: min(600px, 100%);
  margin: 0 auto;
}

.bmd-comment-message {
  margin-bottom: 14px;
  color: #0f172a;
}

.bmd-comment-editor {
  display: grid;
  grid-template-columns: 120px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
}

.bmd-comment-textarea {
  width: 100%;
  min-height: 60px;
  resize: vertical;
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.2rem;
  color: #0f172a;
}

.bmd-dialog-comments {
  width: 650px;
  background: #fff;
}

.bmd-dialog-comments .bmd-body {
  padding: 20px 25px 24px;
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/slurry-details/popups/batch-measure-material-dialog/batch-measure-material-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,MAAM;AACR;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,MAAM;EACN,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,oBAAe;OAAf,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,aAAa;EACb,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB","sourcesContent":[".legacy-batch-measure-dialog .mat-mdc-dialog-surface {\n  background: transparent;\n  border-radius: 0;\n  box-shadow: none;\n  overflow: visible;\n}\n\n.legacy-batch-measure-dialog .mat-mdc-dialog-content,\n.legacy-batch-measure-dialog .mat-mdc-dialog-container {\n  padding: 0;\n}\n\n.bmd-dialog {\n  background: #fff;\n  border-radius: 4px;\n  overflow: hidden;\n  width: 1008px;\n  max-width: 95vw;\n  box-sizing: border-box;\n  font-family: 'GothamNarrowBook', Arial, sans-serif;\n}\n\n.bmd-header {\n  background: #0b2d71;\n  padding: 10px 20px;\n  display: flex;\n  align-items: baseline;\n  gap: 0;\n}\n\n.bmd-title-main {\n  color: #fff;\n  font-size: 26px;\n  font-weight: 600;\n}\n\n.bmd-title-sep {\n  color: #fff;\n  font-size: 26px;\n}\n\n.bmd-title-name {\n  color: #fff;\n  font-size: 26px;\n  font-style: italic;\n  font-weight: 400;\n}\n\n.bmd-body {\n  padding: 15px 25px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  font-size: 24px;\n}\n\n.bmd-scan-banner {\n  border: 1px solid #222;\n  padding: 5px 12px;\n  text-align: center;\n  color: maroon;\n  font-weight: 700;\n  margin: 0 15px 18px;\n}\n\n.bmd-scanner-target-note {\n  margin: -10px 15px 14px;\n  color: #374151;\n  font-size: 16px;\n  text-align: center;\n}\n\n.bmd-scanner-input {\n  position: fixed;\n  left: -10000px;\n  top: 0;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.bmd-section-label {\n  font-weight: 700;\n  color: #111;\n  margin: 0 0 7px 34px;\n}\n\n.bmd-row {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-left: 59px;\n  margin-bottom: 28px;\n}\n\n.bmd-label-w1 {\n  flex: 0 0 130px;\n  color: #374151;\n}\n\n.bmd-label-w2 {\n  flex: 0 0 110px;\n  color: #374151;\n  margin-left: 30px;\n}\n\n.bmd-value-box {\n  flex: 0 0 266px;\n  width: 266px;\n  min-width: 266px;\n  max-width: 266px;\n  padding: 4px 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 2px;\n  background: #f3f4f6;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  font-size: 24px;\n}\n\n.bmd-input-box {\n  flex: 0 0 266px;\n  width: 266px;\n  min-width: 266px;\n  max-width: 266px;\n  box-sizing: border-box;\n  height: 40px;\n  font-size: 24px;\n}\n\n.bmd-scale-note {\n  margin: -18px 0 18px 454px;\n  font-size: 16px;\n  color: #374151;\n}\n\n.bmd-comments-input {\n  flex: 1;\n  min-width: 120px;\n  box-sizing: border-box;\n  font-size: 24px;\n}\n\n.bmd-container-grid {\n  display: grid;\n  grid-template-columns: 130px 266px 140px 266px;\n  column-gap: 5px;\n  row-gap: 7px;\n  align-items: center;\n  margin-left: 59px;\n  margin-bottom: 25px;\n}\n\n.bmd-container-grid .bmd-label-w2 {\n  margin-left: 0;\n  padding-left: 30px;\n  box-sizing: border-box;\n}\n\n.bmd-container-grid .bmd-value-box {\n  flex-basis: auto;\n  width: 266px;\n}\n\n.bmd-check-cell {\n  grid-column: 1 / 3;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0;\n}\n\n.bmd-check-cell input {\n  width: 14px;\n  height: 14px;\n  margin: 0;\n}\n\n.bmd-container-grid button {\n  grid-column: 4;\n  width: 266px;\n  min-height: 40px;\n  font-size: 18px;\n}\n\n.bmd-notes {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 8px;\n  font-size: 18px;\n  margin-left: 59px;\n}\n\n.bmd-error {\n  color: #dc2626;\n}\n\n.bmd-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 10px;\n  border-top: 1px solid #e2e8f0;\n  margin-top: 0;\n}\n\n.bmd-actions button {\n  width: 100px;\n  min-height: 34px;\n  font-size: 18px;\n}\n\n.bmd-critical-warning {\n  border: 2px solid #b91c1c;\n  background: #fef2f2;\n  color: #b91c1c;\n  font-size: 22px;\n  font-weight: 700;\n  margin: 0 15px 18px;\n  padding: 8px 12px;\n  text-align: center;\n}\n\n.bmd-comment-dialog {\n  width: min(600px, 100%);\n  margin: 0 auto;\n}\n\n.bmd-comment-message {\n  margin-bottom: 14px;\n  color: #0f172a;\n}\n\n.bmd-comment-editor {\n  display: grid;\n  grid-template-columns: 120px minmax(0, 1fr);\n  align-items: center;\n  gap: 12px;\n}\n\n.bmd-comment-textarea {\n  width: 100%;\n  min-height: 60px;\n  resize: vertical;\n  background: #fff;\n  border: 1px solid #ced4da;\n  border-radius: 0.2rem;\n  color: #0f172a;\n}\n\n.bmd-dialog-comments {\n  width: 650px;\n  background: #fff;\n}\n\n.bmd-dialog-comments .bmd-body {\n  padding: 20px 25px 24px;\n  font-size: 18px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
